import ErrorBoundary from 'components/ErrorBoundary';
import React, { useState, useEffect } from 'react'
import { Card, CardBody, Container } from 'reactstrap';
import SearchContainer from './SearchContainer';
import { ToastContainer } from 'react-toastify';
import { faAngleUp } from "@fortawesome/free-solid-svg-icons";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons";
import useContextService from 'hooks/useContextService';
import DrugcatalogTable from './DrugcatalogTable';
import useAxios from 'hooks/useAxios';
import { onExport } from 'utils/helper';
import { cloneDeep } from 'lodash';
import Loader from 'components/Loader';

let filters = [];
let reValues = {}
const DrugCatalog = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalItem, setTotalItem] = useState(0);
  const [collapseSider, setcollapseSider] = useState(false);
  const [selectedOption, setOptionSelected] = useState({ optionSelected: '-1' });
  const [selectedOpt, setOptSelected] = useState({ optSelected: '-1' });
  const [accountType, setAccountype] = useState(1);
  const [columnFilters, setColumnFilters] = useState([]);

  const [non340BTenantID, setNon340BTenantID] = useState('');
  const {
    states: { drugcatalog },
    setStates,
  } = useContextService();
  const API = useAxios();
  const { search, thirdPartyAdmin, coveredEntity, searchTerms } = drugcatalog;
  const { tenantID } = thirdPartyAdmin;
  useEffect(() => {
    if (searchTerms.thirdPartyAdminID) handleSearch(searchTerms);
  }, []);

  const toggleSider = () => {
    setcollapseSider(!collapseSider);
    if (!collapseSider) {
      setCollIcon(faAngleDown);
    } else {
      setCollIcon(faAngleUp);
    }
  };


  const handleSearch = async (filter) => {
    reValues = filter;
    const {
      thirdPartyAdminID,
      coveredEntityIDs,
      pharmacyIDs,
      accountcode,
      wholesalerID,
      chainPharmacyID,
      Non340BTenantID,
      ndc,
      WholesalerAccountID
    } = filter;
    setNon340BTenantID(Non340BTenantID);
    var phIds = [];
    if (pharmacyIDs === undefined) {
      phIds = Array.isArray(filter.pharmacyids)
        ? filter.pharmacyids.map(item => item["value"])
        : [];
    }
    else {
      phIds = pharmacyIDs;
    }
    var covids = [];
    if (coveredEntityIDs === undefined) {
      covids = Array.isArray(filter.ceIds)
        ? filter.ceIds.map(item => item["value"])
        : [];
    }

    else if (typeof coveredEntityIDs === 'object') {
      covids = coveredEntityIDs.value
    }

    else {
      covids = coveredEntityIDs;
    }

    const tableRes = document.querySelector('.table-responsive');
    tableRes.scrollLeft = 0;
    search.filters = filters;
    search.pharmacyIDs = phIds;
    tableRes.scrollLeft = 0;
    search.filters = filters;
    search.pharmacyIDs = [pharmacyIDs.value];
    search.coveredEntityIDS = accountType == 2 ? [] : [covids];
    if (chainPharmacyID == undefined) {
      search.ChainPharmacyID = [];
    } else {
      search.ChainPharmacyID = [parseInt(chainPharmacyID)];
    }
    search.wholesalerID = parseInt(wholesalerID)
    if (ndc) {
      search.Ndc = ndc.toString();
    }
    else {
      search.Ndc = 0;
    }
    search.associateTypeID = searchTerms?.associateTypeID;
    search.WholesalerAccountCode = accountcode == "" ? WholesalerAccountID : accountcode;
    search.ThirdPartyAdminID = searchTerms.thirdPartyAdminID
    await fetchDrugcatalogDetails(search, Non340BTenantID);
  };
  const refetch = () => {
    reValues.Non340BTenantID = non340BTenantID
    handleSearch(reValues);
  };
  const handleReset = () => {
    setColumnFilters(null);
    setData([]);
    setTotalItem(0);
    searchTerms.coveredEntity = [];
    searchTerms.thirdPartyAdmin = [];
    searchTerms.pharmacyIDs = [];
    searchTerms.wholesalerID = [];
    searchTerms.chainpharmacyID = [];
    searchTerms.accountcode = [];
    searchTerms.ndc = [];
    searchTerms.setAccountype = [];
    searchTerms.accountcode = [];
  };
  const handleExport = async () => {
    const filterObj = cloneDeep(search);
    if (columnFilters.filters && columnFilters.filters.length > 0) {
      filterObj.filters = [...filterObj.filters, ...columnFilters.filters];
    }
    var additionalCriteria = {};
    if (accountType == 1 || accountType == "1") {


      additionalCriteria.IsSelectedColumn = false;
      additionalCriteria.TPAId = searchTerms.thirdPartyAdminID || 0;
      filterObj.coveredEntityIDS = [searchTerms.coveredEntityIDs.value] || 0;
      filterObj.pharmacyIDs = [searchTerms.pharmacyIDs.value] || 0;
      filterObj.WholesalerId = searchTerms.wholesalerID || 0;
      filterObj.accountcode = searchTerms.accountcode || 0;

    }
    if (accountType == 2 || accountType == "2") {
      additionalCriteria.IsSelectedColumn = false;

    }
    var payload = {};
    payload.tenantID = accountType == 1 ? tenantID : non340BTenantID;
    payload.gridCode = "DrugCatalog";
    payload.fileTypeCode = "csv";
    payload.criteria = JSON.stringify(filterObj);
    payload.additionalCriteria = JSON.stringify(additionalCriteria);
    const { data } = await API.post(`export/queue`, payload, {
      hasExport: true,
    });
  }
  const handleSearchColumnFilters = async (columnFilters) => {
    const filterObj = cloneDeep(search);
    filterObj.filters = [...filterObj.filters, ...columnFilters];
    setColumnFilters(filterObj);
    await fetchDrugcatalogDetails(filterObj, non340BTenantID);
  };

  const fetchDrugcatalogDetails = async (filters, Non340BTenantID) => {
    setLoading(true);
    try {
      setColumnFilters(filters)
      const { data } = await API.post(`/${accountType == "2" ? Non340BTenantID : tenantID}/DrugCatalogue/All`, filters);
      if (data) {
        setData(data.items);
        setTotalItem(data.totalRecords);
        setLoading(false);
      } else {
        setData([]);
        setTotalItem(0);
        setLoading(false);
      }
    } catch (error) { setLoading(false); }
  };
  const handlePageChange = (filter, haveColFilter) => {
    if (haveColFilter) {
      fetchDrugcatalogDetails(filter, non340BTenantID);
    } else {
      fetchDrugcatalogDetails(filter, non340BTenantID);
    }
    drugcatalog.search = { ...drugcatalog.search, ...filter };
    setStates('drugcatalog', drugcatalog);
  };
  return (
    <div>
      {/* {loading && <Loader opacity={0.01} color='black' />} */}
      <Container fluid className="width_info">
        <div className={collapseSider ? "mb-0" : "mb-3"}>
          <Card className="border-0 shadow-top ">
            <CardBody hidden={collapseSider} className="">
              <ErrorBoundary>
                <SearchContainer
                  setOptionSelected={setOptionSelected}
                  selectedOpt={selectedOpt}
                  setOptSelected={setOptSelected}
                  onReset={handleReset}
                  onSearch={handleSearch}
                  accountType={accountType}
                  setAccountype={setAccountype}
                  loading={loading}
                  setLoading={setLoading}
                />


              </ErrorBoundary>
            </CardBody>
          </Card>
        </div>
        <Card className="border-0 shadow-top">
          <CardBody className="">
            <ErrorBoundary>
              <DrugcatalogTable
                toggleSider={toggleSider}
                collapseSider={collapseSider}
                accountType={accountType}
                data={data}
                loading={loading}
                filters={search}
                totalSize={totalItem}
                thirdPartyAdmin={thirdPartyAdmin}
                onExport={handleExport}
                refetch={refetch}
                selectedOption={selectedOption}

                selectedOpt={selectedOpt}

                onPageChange={handlePageChange}
                onSearchColumnFilters={handleSearchColumnFilters}
              />
            </ErrorBoundary>
          </CardBody>
        </Card>
      </Container>
      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  )
}

export default DrugCatalog